import React from 'react';
import { PersonalLayout } from '../components/PersonalLayout';
import { CurrencyToggle } from '../components/CurrencyToggle';
import { FixedCostsTabs } from '../components/FixedCostsTabs';

// Personal-scope Fixed costs page (was Subscriptions). Same tabs and shared
// components as the Entities page, scoped to the selected person via the
// global entity selector (a single personal entity, or 'All Personal').
export function PersonalSubscriptionsPage() {
  return (
    <PersonalLayout>
      <div className="space-y-6" data-testid="personal-subscriptions-page">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold tracking-tight">Fixed costs</h1>
            <p className="text-muted-foreground mt-1">What we pay personally every month, measured from the bank over the last 3 full months</p>
          </div>
          <CurrencyToggle />
        </div>

        <FixedCostsTabs scope="personal" />
      </div>
    </PersonalLayout>
  );
}
